import type { TOC } from '@ember/component/template-only';
import { array, concat } from '@ember/helper';
import t from 'ember-intl/helpers/t';
import type { Signature as ProviderSig } from 'parog-web/components/forc/provider';

interface Signature {
  Args: {
    form: ProviderSig['Blocks']['content'][0];
  };
}
export default <template>
  <@form.FieldsRadioGroup
    @propertyName='wellBeing'
    @title={{t 'mici-form.wellBeing.long' htmlSafe=true}}
    as |Group|
  >
    {{#each (array '0' '1' '2' '3' '4') as |value|}}
      <Group.FieldRadio
        @value={{value}}
        @label={{t (concat 'mici-form.wellBeing.answers.' value)}}
      />
    {{/each}}
  </@form.FieldsRadioGroup>
</template> satisfies TOC<Signature>;
